import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LayoutDashboard, Columns3, LogOut, User } from "lucide-react";
import { useAuth } from "../App";

export default function MobileNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const isActive = (path) => location.pathname.startsWith(path);

  const items = [
    {
      icon: LayoutDashboard,
      label: "Dasbor",
      path: "/dashboard",
      active: isActive("/dashboard"),
    },
    {
      icon: Columns3,
      label: "Papan",
      path: null, // current board or disabled
      active: isActive("/board"),
    },
  ];

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-black safe-bottom"
      data-testid="mobile-nav"
    >
      <div className="grid grid-cols-4 h-16">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.label}
              onClick={() => item.path && navigate(item.path)}
              disabled={!item.path && !item.active}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
              className={`min-w-0 flex flex-col items-center justify-center gap-0.5 px-1 py-2 transition-colors touch-manipulation ${
                item.active
                  ? "text-klein"
                  : "text-black/50 hover:text-black"
              }`}
            >
              <Icon size={20} strokeWidth={item.active ? 2.5 : 2} />
              <span className="font-mono text-[9px] uppercase tracking-widest">
                {item.label}
              </span>
            </button>
          );
        })}

        {/* User avatar / profile */}
        <button
          onClick={() => {}}
          data-testid="mobile-nav-profil"
          className="min-w-0 flex flex-col items-center justify-center gap-0.5 px-1 py-2 text-black/50 touch-manipulation"
        >
          {user?.picture ? (
            <img
              src={user.picture}
              alt=""
              className="w-6 h-6 border border-black object-cover"
            />
          ) : (
            <User size={20} strokeWidth={2} />
          )}
          <span className="font-mono text-[9px] uppercase tracking-widest">
            Profil
          </span>
        </button>

        {/* Logout */}
        <button
          onClick={async () => {
            await logout();
            navigate("/login", { replace: true });
          }}
          data-testid="mobile-nav-keluar"
          className="min-w-0 flex flex-col items-center justify-center gap-0.5 px-1 py-2 text-black/50 hover:text-signal touch-manipulation"
        >
          <LogOut size={20} strokeWidth={2} />
          <span className="font-mono text-[9px] uppercase tracking-widest">
            Keluar
          </span>
        </button>
      </div>
    </nav>
  );
}
